export function getMonospaceCharCount(element: HTMLElement) {
  // get the computed styles
  const style = window.getComputedStyle(element);

  // get the width of the container and padding
  const containerWidth = parseFloat(style.width);
  const paddingLeft = parseFloat(style.paddingLeft);
  const paddingRight = parseFloat(style.paddingRight);

  // available width for text
  const availableWidth = containerWidth - paddingLeft - paddingRight;

  // for monospace fonts, we can measure a single character
  const testChar = document.createElement('span');
  testChar.style.font = style.font;
  testChar.style.visibility = 'hidden';
  testChar.style.position = 'absolute';
  testChar.textContent = 'X'; // any character will do since it's monospace
  document.body.appendChild(testChar);

  // get the width of a single character
  const charWidth = testChar.getBoundingClientRect().width;
  document.body.removeChild(testChar);

  // calculate how many characters fit
  const visibleChars = Math.floor(availableWidth / charWidth);

  // if the text is being truncated, subtract characters for the ellipsis
  const fullText = element.textContent;

  if (fullText && fullText?.length > visibleChars) {
    return visibleChars - 1;
  }

  return visibleChars;
}
